
import Vue, { defineComponent, computed, ref } from 'vue';
import config from '@/common/config';
import { prefStorage } from '@samknows/utils';
import { persistLocale } from '@/common/helpers/language-switcher';
import { SvgIcon, BaseButton, BaseModal } from '@samknows/design-system';
import { useStore } from '@/common/composables/vuex';
import { useRoute, useRouter } from 'vue-router/composables';

export default defineComponent({
  name: 'LanguageSwitcher',

  components: {
    SvgIcon,
    BaseButton,
    BaseModal
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const locales = ref(config.locales);
    const activeLocale = computed(() => Vue.config.lang);
    const visible = computed({
      get: () => store.state.languageSwitcher.visible,
      set: (value: boolean) =>
        store.commit('languageSwitcher/SET_VISIBILITY', value)
    });

    const changeLocale = (locale: string) => {
      Vue.config.lang = locale;
      prefStorage.set('locale', locale);

      const zdLocale = config.locales.find(
        (localeItem) => localeItem.code === locale && !!localeItem.zdCode
      );
      const zdLocaleCode = zdLocale ? zdLocale.zdCode : 'en-gb';
      prefStorage.set('locale-hc', zdLocaleCode);

      persistLocale(locale).then(() => {
        // On public routes, update the locale in the URL
        if (route?.meta?.public) {
          router.replace({
            ...route,
            query: {
              ...route.query,
              lang: locale.split('-')[0]
            }
          });
        }
        // We still need to trigger a full page reload after updating the route for the app to load in the right locale
        window.location.reload();
      });
    };

    return {
      locales,
      activeLocale,
      visible,
      changeLocale
    };
  }
});
